import React from 'react';
import styled from 'styled-components';

 const Content = styled.div`
  width: 100%;
  height: 132px;
  border: 1px solid #e0e2e6;
  border-radius: 12px;
  padding: 30px 20px;
  p {
    font: 16px;
    color: #667085;
    line-height: 22px;
  }
  h3 {
    margin-top: 5px;
    font-size: 30px;
    color: #3730a3;
    line-height: 38px;
  }
`;

const Card = ({ totalCount, text }) => {
  return (
    <Content>
      <div>
        <p>{text}</p>
        <h3>{totalCount}</h3>
      </div>
    </Content>
  );
};

export default Card;
